
import React from 'react';
import styled from 'styled-components';
import ScrollOceans from '../../components/ScrollOceans/ScrollOceans';
import ScrollLand from '../../components/ScrollLand/ScrollLand';
import ScrollAtmosphere from '../../components/ScrollAtmosphere/ScrollAtmosphere';
import ScrollNearspace from '../../components/ScrollNearspace/ScrollNearspace';
import {Link} from 'react-router-dom';

const Container = styled.div`
  display: flex;
  width: auto;
  height:auto;
  flex-wrap: nowrap;
  flex-direction: row;
  overflow-x: scroll;


  -webkit-overflow-scrolling: touch;
  ::-webkit-scrollbar {
    display: none;
 }

`;
const Box = styled.div`
  flex-shrink: 0 ;
  flex: 0 0 auto;
  width:200px;
  height:170px;
  padding:10px;
  background-color:#000;
  border-radius:9px;
  opacity:50%;
`;

const Impactwrapper = styled.div`
  margin-left:15px;
  margin-top:15px;
  margin-right:15px;
  margin-bottom:15px;
    transform: scale(1);
  transition: all 0.5s;
      &:hover {
  transform: scale(1.04);
    transition: all 0.5s; 
}
`;
const Space = styled.div`
  margin:0px;
  @media (max-width: 768px) {
    margin:7px;

  }
`;

class CarouselExplore extends React.Component {
  render () {
   return (

  <Container>
    <Space/>
    <Impactwrapper><Link to="/Oceans"><ScrollOceans/></Link></Impactwrapper>
    <Impactwrapper><Link to="/Land"><ScrollLand/></Link></Impactwrapper>
    <Impactwrapper><Link to="/Atmosphere"><ScrollAtmosphere/></Link></Impactwrapper>
    <Impactwrapper><Link to="/Near-Space"><ScrollNearspace/></Link></Impactwrapper>     
  </Container>
  );
 }
}
export default CarouselExplore;
